import { CONTRACT_TYPE } from 'utils/globalConst';

export const handleSubmit = (values: any, { props }: any) => {
  const {
    firstName,
    lastName,
    birthday: bday,
    cin,
    email,
    phoneNumber: phone,
    isContacterParSaham: comCheck,
    isContratEpargne,
    organization,
    isAssuranceSante,
    drpp,
    membershipNumber,
  } = values;

  let result: any = {
    firstName,
    lastName,
    bday,
    cin,
    email,
    phone,
    comCheck,
    isContratEpargne,
    contractType: CONTRACT_TYPE.other,
  };
  if (isContratEpargne) {
    const {
      numPolice,
      numAdhesion,
      product,
      dateEffet,
      ppr,
      matricule,
    } = values;
    result = {
      ...result,
      numAdhesion: numAdhesion,
      numPolice: numPolice,
      dateEffet: dateEffet,
      codeProduit: product,
      ppr: ppr,
      matricule: matricule,
      contractType: CONTRACT_TYPE.saving,
    };
  }

  if (isAssuranceSante) {
    result = {
      ...result,
      organisme: organization.policyNumber,
      numAdhesion: membershipNumber,
      drpp,
      contractType: CONTRACT_TYPE.amc,
    };
  }

  return props.onSubmit({ ...result });
};
